'use client';
/** Alias для Math.min */ var min = Math.min;
/** Alias для Math.max */ var max = Math.max;
/** Alias для Math.round */ var round = Math.round;
/** Alias для Math.floor */ var floor = Math.floor;
/** Alias для Math.ceil */ var ceil = Math.ceil;

export { ceil, floor, max, min, round };
